import { SortableHeader, SortableHeadersGroup } from 'components/Shared';
import type { PaginatedCancelationReason } from 'contracts/CancelationReasons';
import { SortingParams } from 'contracts/Common';
import React, { useCallback } from 'react';
import * as S from './styles';

interface Props {
  reasons: PaginatedCancelationReason[];
  onSort?: (sort: SortingParams) => void;
  currentSort: SortingParams;
}

interface ItemProps {
  reason: PaginatedCancelationReason;
}

export const ReasonsList: React.FC<Props> = ({
  reasons,
  onSort,
  currentSort,
}) => {
  const Item = useCallback(({ reason }: ItemProps): JSX.Element => {
    const { id, name, blockedAt } = reason;

    return (
      <S.ListItem>
        <S.Column>{id}</S.Column>
        <S.Column>{name}</S.Column>
        <S.Column>{blockedAt && <S.LockIcon />}</S.Column>
        <S.ActionsColumn>
          <S.LinkActionButton
            to={`/configuracoes/justificativas-cancelamento/${id}/editar`}
          >
            <S.EditIcon />
          </S.LinkActionButton>
        </S.ActionsColumn>
      </S.ListItem>
    );
  }, []);

  return (
    <S.List>
      <S.ListHeader>
        <SortableHeadersGroup onSort={onSort} currentSort={currentSort}>
          <SortableHeader column="id" label="ID" />
          <SortableHeader column="name" label="NOME" />
          <div></div>
        </SortableHeadersGroup>
      </S.ListHeader>
      {reasons.map((setup) => (
        <Item key={setup.id} reason={setup} />
      ))}
    </S.List>
  );
};
